import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import AIPricingInsight from './AIPricingInsight';

const QuotePreview = ({ quote, customerName, projectType, squareFeet, markup, onApplyMarkup }) => {
  if (!quote) return null;

  return (
    <Card className="border-2 border-blue-200 shadow-xl bg-gradient-to-br from-slate-900 to-slate-800 text-white">
      <CardHeader className="border-b border-slate-700">
        <div className="flex items-center justify-between">
          <CardTitle className="text-white">Quote Preview</CardTitle>
          <Badge className="bg-green-600 text-white">Live Update</Badge>
        </div>
      </CardHeader>
      <CardContent className="p-6 space-y-6">
        {customerName && (
          <div className="pb-4 border-b border-slate-700">
            <p className="text-sm text-slate-400">Customer</p>
            <p className="text-lg font-semibold">{customerName}</p>
          </div>
        )}

        <div className="space-y-3">
          <div className="flex justify-between items-center">
            <span className="text-slate-300 text-sm">Project Type</span>
            <span className="font-semibold">{quote.projectName}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-slate-300 text-sm">Measurement</span>
            <span className="font-semibold">{quote.measurement}</span>
          </div>
        </div>

        <div className="space-y-3 pt-4 border-t border-slate-700">
          <div className="flex justify-between items-center">
            <span className="text-slate-300">Materials</span>
            <span className="font-semibold">${quote.materialCost}</span>
          </div>
          <div className="flex justify-between items-center">
            <div>
              <span className="text-slate-300">Labor</span>
              <span className="text-xs text-slate-500 ml-2">({quote.laborHours} hrs)</span>
            </div>
            <span className="font-semibold">${quote.laborCost}</span>
          </div>
          {parseFloat(quote.addOnsCost) > 0 && (
            <div className="flex justify-between items-center">
              <span className="text-slate-300">Add-ons</span>
              <span className="font-semibold">${quote.addOnsCost}</span>
            </div>
          )}
          <div className="flex justify-between items-center pt-2 border-t border-slate-700">
            <span className="text-slate-300">Subtotal</span>
            <span className="font-semibold">${quote.subtotal}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-slate-300">Markup ({quote.markupPercent}%)</span>
            <span className="font-semibold">${quote.markup}</span>
          </div>
        </div>

        <div className="flex justify-between items-center pt-4 border-t-2 border-slate-600 text-xl">
          <span className="font-bold">Total</span>
          <span className="font-bold text-green-400">${quote.total}</span>
        </div>

        <div className="mt-4 p-4 bg-slate-800 rounded-lg border border-slate-700">
          <div className="flex items-center justify-between">
            <span className="text-sm text-slate-400">Your Profit</span>
            <span className="text-lg font-bold text-green-400">${quote.markup}</span>
          </div>
        </div>

        {/* AI Pricing Insight */}
        <AIPricingInsight
          projectType={projectType}
          total={parseFloat(quote.total) || 0}
          markupPercent={parseFloat(markup ?? quote.markupPercent) || 0}
          squareFeet={squareFeet}
          onApplyMarkup={onApplyMarkup}
        />
      </CardContent>
    </Card>
  );
};

export default QuotePreview;
